/**
 * Engine Editor cross-link URL constants per Engine Editor V1 Day 1 P6.
 *
 * ADR 36 + 38 hardcoded prod-domain convention (parallel structure to
 * apps/arbi-dev/src/lib/atlas/atlasUrls.ts). Per-file URL constants with
 * explicit anchor IDs verified against Settings.tsx + Directory.tsx
 * SectionId enums at Atlas Day 2 Phase 0 — reused here for parity.
 *
 * Day 1 subset scope: outbound deflection targets for sub-shape 2 / 3b /
 * 4b plain / 4b-deferred cell rendering + "View as Atlas" page-altitude
 * affordance. Day 2 adds bswc anchor constants for full-row consolidation
 * cross-link migration; Day 3 adds brands.enforces_map MAP enforcement
 * anchor + completes Atlas cross-link migration coordination.
 */

const ARBI_ROOT_BASE = 'https://arbi.ironcladsupply.co';
const ARBI_DEV_BASE = 'https://arbi-dev.ironcladsupply.co';

// ── Settings cross-links (Settings.tsx SectionId enum; Atlas Day 2 Phase 0 #14-#16 verified) ──

export const URL_SETTINGS_PARAMS = `${ARBI_ROOT_BASE}/settings#section-params`;
/** @public — pinned-by-source-assertion (U11 census C1): root tests assert this export's source text. */
export const URL_SETTINGS_COST_LINE_ITEMS = `${ARBI_ROOT_BASE}/settings#section-cost-line-items`;
export const URL_SETTINGS_CHANNELS_AND_PATHS = `${ARBI_ROOT_BASE}/settings#section-channels-and-paths`;

// ── Directory cross-links (Directory.tsx SectionId enum; Atlas Day 2 Phase 0 #14-#16 verified) ──

export const URL_DIRECTORY_DISTRIBUTORS = `${ARBI_ROOT_BASE}/directory#section-distributors`;
export const URL_DIRECTORY_SUPPLIERS = `${ARBI_ROOT_BASE}/directory#section-suppliers`;
export const URL_DIRECTORY_BRANDS = `${ARBI_ROOT_BASE}/directory#section-brands`;
export const URL_DIRECTORY_MANUFACTURERS = `${ARBI_ROOT_BASE}/directory#section-manufacturers`;
export const URL_DIRECTORY_CATEGORIES = `${ARBI_ROOT_BASE}/directory#section-categories`;

// ── Files / Finance cross-links (anchor IDs to be verified against arbi-root pages at consumer use; placeholder shape per Files.tsx + Finance.tsx convention) ──

export const URL_FILES_ALGOPIX_IMPORT = `${ARBI_ROOT_BASE}/files#section-algopix-import`;
export const URL_FINANCE_CREDIT_AND_CASH = `${ARBI_ROOT_BASE}/finance#section-credit-and-cash`;

// ── arbi-dev cross-links ──

// "View as Atlas" page-altitude affordance per scope-doc §2 line 258
export const URL_DEV_ENGINE_ATLAS = `${ARBI_DEV_BASE}/admin/engine-atlas`;

// The deprecated arbi-dev legacy-admin URL constant was removed at Day 3 P5
// per build-plan §2.3 P5 BuyScoreWeights deprecation. Was Day 1 leftover;
// already orphaned post-Day-2.5 (no remaining consumer within engine-editor
// namespace). Comment scrubbed of literal constant name at Day 4 Phase A per
// defensive-cleanup discipline.

// ── Engine Editor dedicated edit routes per scope-doc §2 amended ──

// Weight components dedicated edit route per Day 2 P2.
// Single editing surface for bswc full-row consolidation per scope-doc §2
// amended bswc two-cell rendering framing — both Weight components region card
// (substrate × calculation cell) AND Buy Score composition sub-region
// (transformation × decision cluster) cross-link here.
// React Router-internal path (not absolute URL) — consumed via react-router
// useNavigate per Atlas inspect-route precedent (Atlas inspect URLs are
// react-router-internal paths starting with /admin/, not full prod URLs).
export const URL_ENGINE_EDITOR_WEIGHT_COMPONENTS = '/admin/engine-editor/weight-components';
